import { render, staticRenderFns } from "./krSelect-dropdown.vue?vue&type=template&id=cb475ba2&"
import script from "./krSelect-dropdown.vue?vue&type=script&lang=js&"
export * from "./krSelect-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports